import React, { useState } from 'react';
import { TextField, FormControl } from '@material-ui/core';
// import classes from '*.module.css';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    formControl: {
        width: '70%',
        padding: '20px 0',
        textAlign: 'left',
        '& >*': {
            width: '100%'
        },
        [theme.breakpoints.down('xs')]: {
            width: '100%',
            padding: '10px 0'
        }
    }
}));

export const TextInput = (props) => {
    const classes = useStyles();
    return (
        <div className={classes.formControl}>
            <TextField
                variant={'standard'}
                color="secondary"
                {...props}
            >
                {props.children}
            </TextField>
        </div>
    )

}
